import { render, staticRenderFns } from "./GoldBalanceWithdrawList.vue?vue&type=template&id=b568d830&scoped=true"
import script from "./GoldBalanceWithdrawList.vue?vue&type=script&lang=js"
export * from "./GoldBalanceWithdrawList.vue?vue&type=script&lang=js"
import style0 from "./GoldBalanceWithdrawList.vue?vue&type=style&index=0&id=b568d830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568d830",
  null
  
)

export default component.exports